import { render, staticRenderFns } from "./CoursewareLtiBlock.vue?vue&type=template&id=b6cb252a&scoped=true&"
import script from "./CoursewareLtiBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareLtiBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareLtiBlock.vue?vue&type=style&index=0&id=b6cb252a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cb252a",
  null
  
)

export default component.exports